import { render, staticRenderFns } from "./BannerNotifications.vue?vue&type=template&id=14aeb270&scoped=true&"
import script from "./BannerNotifications.vue?vue&type=script&lang=js&"
export * from "./BannerNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BannerNotifications.vue?vue&type=style&index=0&id=14aeb270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aeb270",
  null
  
)

export default component.exports